import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    backgroundColor: 'gray',
    border: '6px solid white',
    height: (props) => (props.height ? props.height : '33vh'),
    width: '100%',
  },
  video: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0px',
    left: '0px',
    objectFit: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
}));

export default function PlaceHolderTile(props) {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <video data-testid="placeholder-video-tile" className={classes.video} />
    </div>
  );
}
